.card {
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 8px 16px;
}

.imageLink {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #fff;
  position: relative;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.imagePlaceholder {
  width: 100%;
  height: 100%;
  background: #f3efe9;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  width: 100%;
}

.swatches {
  margin-bottom: 4px;
}

.name {
  font-family: var(--font-body);
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--color-ink);
  line-height: 1.3;
  max-width: 100%;
}

.name:hover { text-decoration: underline; }

.price {
  font-size: 0.95rem;
  color: var(--color-ink);
  font-weight: 500;
}

.quickAdd {
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-ink);
  color: #fff;
  border: 0;
  border-radius: 999px;
  padding: 8px 14px 8px 10px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 160ms ease, transform 180ms cubic-bezier(0.22, 1, 0.36, 1), background 120ms ease;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.14);
}

.quickAdd:hover { background: var(--color-ember); color: #111; }

.card:hover .quickAdd,
.card:focus-within .quickAdd {
  opacity: 1;
  transform: translateY(0);
}

.quickAddText { line-height: 1; }

/* Touch-only devices: keep the button visible since there's no hover. */
@media (hover: none) {
  .quickAdd { opacity: 1; transform: none; padding: 8px 12px; }
  .quickAddText { display: none; }
}

/* Portrait phones — every tile shrinks a touch (less padding, smaller
   typography, tighter swatches) so the 2-column grid feels lighter and
   the surrounding page padding has room to breathe. */
@media (max-width: 540px) and (orientation: portrait) {
  .card { padding: 4px 4px 12px; }
  .body { gap: 4px; margin-top: 6px; }
  .name { font-size: 0.85rem; line-height: 1.25; }
  .price { font-size: 0.85rem; }
  .quickAdd { right: 6px; bottom: 6px; padding: 6px; }
  .quickAddText { display: none; }
}
